import type {
    StripeCardRequest,
    StripeBankAccountRequest,
    StripeBankAccountVerifyRequest,
    SavedPaymentMethod
} from '~/types';
import { BaseModel } from '~/models/base-model';


export class SavedPaymentMethodModel extends BaseModel<SavedPaymentMethod> {
    type = null;
    description = null;
    isDefault = null;
    created = null;
    brand = null;
    logo = null;
    detail = null;
}

/**
*  @deprecated
*/
export class StripeCardAddModel extends BaseModel<StripeCardRequest> {
    object = 'card';
    number = null;
    expMonth = null;
    expYear = null;
    cvc = null;
}

/**
*  @deprecated
*/
export class StripeBankAccountAddModel extends BaseModel<StripeBankAccountRequest> {
    object = 'bank_account';
    country = null;
    currency = null;
    accountNumber = null;
    routingNumber = null;
    accountHolderName = null;
    accountHolderType = null;
}

/**
*  @deprecated
*/
export class StripeBankAccountVerifyModel extends BaseModel<StripeBankAccountRequest> {
    amounts = [];
}
